import { render, staticRenderFns } from "./complaintAdd.vue?vue&type=template&id=718f375c&scoped=true&"
import script from "./complaintAdd.vue?vue&type=script&lang=js&"
export * from "./complaintAdd.vue?vue&type=script&lang=js&"
import style0 from "./complaintAdd.vue?vue&type=style&index=0&id=718f375c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "718f375c",
  null
  
)

export default component.exports